import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import * as Utils from '_utils';
import * as Styles from './Modal.module.scss';
export function Modal(props) {
    const ref = React.useRef(null);
    React.useEffect(() => {
        if (props.open) {
            if (ref.current?.open) {
                return;
            }
            ref.current?.showModal();
        }
        else {
            ref.current?.close();
        }
    }, [props.open]);
    const classNames = {
        [Styles.wide]: props.size === 'wide',
        [Styles.full]: props.size === 'full',
    };
    return (_jsx("dialog", { ref: ref, onClose: props.onClose, className: Utils.classNames(classNames), children: _jsx(DialogContext.Provider, { value: { close: props.onClose }, children: props.children }) }));
}
export const DialogContext = React.createContext({});
